
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-tools',
  imports: [
    FormsModule,
    RouterModule
],
  templateUrl: './tools.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tools.component.scss'
})
export class ToolsComponent {

}
